module.exports = __webpack_public_path__ + "img/back-icon.43c3c5a6.svg";